/* eslint-disable no-console */
import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Confirm Result component
 * @description Angular utility component. Show Success/Failure dialog based on input from parent component
 */
@Component({
  selector: 'ap-modal-confirm-result',
  templateUrl: './confirm-result.component.html',
})
export class ConfirmResultComponent {
  @Input() resultText?: string;
  @Input() extraResultText = '';
  @Input() extraResultText2 = '';
  @Input() extraResultClass?: string;
  @Input() extraErrorMessageText = '';

  @Input() alertText = '';
  @Input() btnText?: string;
  @Input() btnText2?: string;
  @Input() isSuccess: boolean;

  @Input() isStep2fa = false;
  @Input() isMultiutente = false;

  @Output() onSubmit = new EventEmitter<void>();
  @Output() onAnchorSubmit = new EventEmitter<true>();

  svgIconOK = 'content/images/icons/confirm-circle.svg';
  svgIconKO = 'content/images/icons/confirm-circle-ko.svg';

  constructor() {
    this.isSuccess = false;
  }

  onAnchorClicked(anchorToGo: true): void {
    this.onAnchorSubmit.next(anchorToGo);
  }

  /**
   * After user require to close the dialog, return control to parent component
   */
  confirmSubmit(): void {
    this.onSubmit.next();
  }
}
